import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [

    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          name: 'admin',
          redirect: '/admin/dashboard',
          meta: {
            is_admin:true,
            requiresAuth: true,
          }
        },

        // =============================================================================
        // @@@@@@ ======= New Router 08.27======== @@@@@@@
        // =============================================================================
        // =============================================================================
        // ========ADMIN ROUTES========
        // =============================================================================

        // ===============================================================
        // Reseller invoice
        // ===============================================================
        {
          path: '/admin/reseller',
          name: 'Admin-reseller',
          redirect: { name: 'admin-reseller-list' },
          component: () => import('./views/admin/reseller/Index.vue'),
          meta: {
            is_admin:true,
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'admin-reseller-list',
              component: () => import('./views/admin/reseller/List.vue'),
              meta: {
                is_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Resellers',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Resellers', active: true }
                ],
              }
            },
            {
              path: 'add',
              name: 'admin-reseller-add',
              component: () => import('./views/admin/reseller/Add.vue'),
              meta: {
                is_admin:true,
                requiresAuth: true,
                pageTitle: 'Resellers',
                rule: 'editor',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Resellers', url: '/admin/reseller' },
                  { title: 'Add Reseller', active: true },
                ]
              },
            },
            {
              path: 'edit/:id',
              name: 'admin-reseller-edit',
              component: () => import('./views/admin/reseller/Edit.vue'),
              meta: {
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Resellers',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Resellers', url: '/admin/reseller' },
                  { title: 'Edit', active: true }
                ]
              },
            },
            {
              path: 'add-manual-payment',
              name: 'admin-reseller-add-manual-payment',
              component: () => import('./views/admin/reseller/AddManualPayment.vue'),
              meta: {
                is_admin:true,
                requiresAuth: true,
                pageTitle: 'Resellers',
                rule: 'editor',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Resellers', url: '/admin/reseller' },
                  { title: 'Add Manual Payment', active: true }
                ]
              },
            },
            {
              path: ':id/transaction-history',
              name: 'admin-reseller-transaction-history',
              redirect: { name: 'admin-reseller-transaction-history-list' },
              component: () => import('./views/admin/reseller/transactionHistory/Index.vue'),
              meta: {
                is_admin:true,
                requiresAuth: true,
                rule: 'editor',
              },
              children: [
                {
                  path: 'list',
                  name: 'admin-reseller-transaction-history-list',
                  component: () => import('./views/admin/reseller/transactionHistory/List.vue'),
                  meta: {
                    is_admin:true,
                    requiresAuth: true,
                    rule: 'editor',
                    pageTitle: 'Resellers',
                    breadcrumb: [
                      { title: 'Home', url: '/' },
                      { title: 'Resellers', url: '/admin/reseller' },
                      { title: 'Transaction History', active: true }
                    ]
                  }
                }
              ]
            },
            {
              path: ':id/invoice-history',
              name: 'admin-reseller-invoice-history',
              redirect: { name: 'admin-reseller-invoice-history-list' },
              component: () => import('./views/admin/reseller/invoiceHistory/Index.vue'),
              meta: {
                is_admin:true,
                requiresAuth: true,
                rule: 'editor',
              },
              children: [
                {
                  path: 'list',
                  name: 'admin-reseller-invoice-history-list',
                  component: () => import('./views/admin/reseller/invoiceHistory/List.vue'),
                  meta: {
                    is_admin:true,
                    requiresAuth: true,
                    rule: 'editor',
                    pageTitle: 'Resellers',
                    breadcrumb: [
                      { title: 'Home', url: '/' },
                      { title: 'Resellers', url: '/admin/reseller' },
                      { title: 'Invoice History', active: true }
                    ]
                  }
                }
              ]
            }
          ]
        },
        // =============================================================================
        //  Admin Reporting
        // =============================================================================
        {
          path: '/admin/reporting/destination-report',
          name: 'admin-reporting-destination-report',
          redirect: { name: 'admin-reporting-destination-report-list' },
          component: () => import('./views/admin/reporting/Destination Report/Index.vue'),
          meta: {
            is_admin:true,
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'admin-reporting-destination-report-list',
              component: () => import('./views/admin/reporting/Destination Report/List.vue'),
              meta: {
                is_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Reporting',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Destination Report', active: true }
                ]
              },
            },
          ]
        },
        // =============================================================================
        //
        // =============================================================================
        // ===============================================================
        // Product
        // ===============================================================
        {
          path: '/admin/product',
          name: 'Admin-product',
          redirect: { name: 'admin-product-list' },
          component: () => import('./views/admin/product/Index.vue'),
          meta: {
            is_admin:true,
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'admin-product-list',
              component: () => import('./views/admin/product/List.vue'),
              meta: {
                is_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Product',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Product', active: true }
                ],
              }
            },
            {
              path: 'add',
              name: 'admin-product-add',
              component: () => import('./views/admin/product/Add.vue'),
              meta: {
                is_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Product',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Product', active: true }
                ],
              }
            },
            {
              path: 'edit',
              name: 'admin-product-edit',
              component: () => import('./views/admin/product/Edit.vue'),
              meta: {
                is_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Product',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Product', active: true }
                ],
              }
            },
          ]
        },
        // ===============================================================
        // Number
        // ===============================================================
        {
          path: '/admin/number',
          name: 'Admin-number',
          redirect: { name: 'admin-number-list' },
          component: () => import('./views/admin/number/Index.vue'),
          meta: {
            is_admin:true,
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'admin-number-list',
              component: () => import('./views/admin/number/List.vue'),
              meta: {
                is_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Number',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Number', active: true }
                ],
              }
            },
          ]
        },
        // ===============================================================
        // Billing Invoice
        // ===============================================================
        {
          path: '/admin/billing',
          name: 'admin-billing',
          redirect: { name: 'admin-billing-invoice-list' }
        },
        {
          path: '/admin/billing/invoice',
          name: 'admin-billing-invoice',
          redirect: { name: 'admin-billing-invoice-list' },
          component: () => import('./views/admin/billing/invoice/Index.vue'),
          meta: {
            is_admin:true,
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'admin-billing-invoice-list',
              component: () => import('./views/admin/billing/invoice/List.vue'),
              meta: {
                is_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Billing',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Invoice', active: true }
                ]
              },
            },
            {
              path: 'add',
              name: 'admin-billing-invoice-add',
              component: () => import('./views/admin/billing/invoice/Add.vue'),
              meta: {
                is_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Billing',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Invoice', url: '/admin/billing/invoice/list' },
                  { title: 'Add', active: true }
                ]
              },
            }
          ]
        },

        // ===============================================================
        // Billing Payment
        // ===============================================================
        {
          path: '/admin/billing/payment',
          name: 'admin-billing-payment',
          redirect: { name: 'admin-billing-payment-list' },
          component: () => import('./views/admin/billing/payment/Index.vue'),
          meta: {
            is_admin:true,
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'admin-billing-payment-list',
              component: () => import('./views/admin/billing/payment/List.vue'),
              meta: {
                is_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Billing',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Payment', active: true }
                ]
              },
            },
            {
              path: 'add-manual-payment',
              name: 'admin-billing-payment-add',
              component: () => import('./views/admin/billing/payment/Add.vue'),
              meta: {
                is_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Billing',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Payment', url: '/admin/billing/payment' },
                  { title: 'Create', active: true }
                ]
              },
            },
          ]
        },

        // ===============================================================
        // Template Approval
        // ===============================================================
        {
          path: '/admin/template-approval',
          name: 'admin-template-approval',
          redirect: { name: 'admin-template-approval-list' },
          component: () => import('./views/admin/template-approval/Index.vue'),
          meta: {
            is_admin:true,
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'admin-template-approval-list',
              component: () => import('./views/admin/template-approval/List.vue'),
              meta: {
                is_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Template Approval',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Template Approval', active: true }
                ]
              },
            }
          ]
        },
        {
          path: '/admin/dashboard',
          name: 'Admin-dashboard',
          component: () => import('./views/admin/dashboard/admindashboard.vue'),
          meta: {
            is_admin:true,
            requiresAuth: true,
            rule: 'admin',
            pageTitle: 'Dashboard',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Dashboard', active: true }
            ]
          }
        },

        // ===============================================================
        // DID
        // ===============================================================
        {
          path: '/admin/did',
          name: 'admin-did',
          redirect: { name: 'admin-did-list' },
          component: () => import('./views/admin/did/Index.vue'),
          meta: {
            is_admin:true,
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'admin-did-list',
              component: () => import('./views/admin/did/List.vue'),
              meta: {
                is_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'DID',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'DID', active: true }
                ]
              },
            },
            {
              path: 'add',
              name: 'admin-did-add',
              component: () => import('./views/admin/did/Add.vue'),
              meta: {
                is_admin:true,
                requiresAuth: true,
                pageTitle: 'DID',
                rule: 'editor',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'DID', url: '/admin/did' },
                  { title: 'Add DID', active: true },
                ]
              },
            },
            {
              path: 'import-log',
              name: 'admin-did-import-log',
              redirect: { name: 'admin-did-import-log-list' },
              component: () => import('./views/admin/did/import-log/Index.vue'),
              meta: {
                is_admin:true,
                requiresAuth: true,
                rule: 'editor',
              },
              children: [
                {
                  path: 'list',
                  name: 'admin-did-import-log-list',
                  component: () => import('./views/admin/did/import-log/List.vue'),
                  meta: {
                    requiresAuth: true,
                    rule: 'editor',
                    pageTitle: 'DID',
                    breadcrumb: [
                      { title: 'Home', url: '/' },
                      { title: 'DID', url: '/admin/did' },
                      { title: 'Import Log', active: true }
                    ]
                  },
                }
              ]
            },
            {
              path: 'import-did',
              name: 'admin-did-import-did',
              redirect: { name: 'admin-did-import-did-import' },
              component: () => import('./views/admin/did/import-did/Index.vue'),
              meta: {
                is_admin:true,
                requiresAuth: true,
                rule: 'editor',
              },
              children: [
                {
                  path: 'import',
                  name: 'admin-did-import-did-import',
                  component: () => import('./views/admin/did/import-did/Import.vue'),
                  meta: {
                    is_admin:true,
                    requiresAuth: true,
                    rule: 'editor',
                    pageTitle: 'DID',
                    breadcrumb: [
                      { title: 'Home', url: '/' },
                      { title: 'DID', url: '/admin/did' },
                      { title: 'Import DID', active: true }
                    ]
                  },
                }
              ]
            }
          ]
        },
        {
          path: '/admin/did/import',
          name: 'admin-did-import',
          redirect: { name: 'admin-did-import-list' },
          component: () => import('./views/admin/did/import-log1/Index.vue'),
          meta: {
            is_admin:true,
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'admin-did-import-list',
              component: () => import('./views/admin/did/import-log1/List.vue'),
              meta: {
                is_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'DID',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Import Log', active: true }
                ]
              },
            },
          ]
        },
        // ===============================================================
        // Clients Companies
        // ===============================================================
        {
          path: '/admin/clients',
          name: 'admin-clients',
          redirect: { name: 'admin-companies-list' }
        },
        {
          path: '/admin/clients/companies',
          name: 'admin-companies',
          redirect: { name: 'admin-companies-list' },
          component: () => import('./views/admin/clients/companies/Index.vue'),
          meta: {
            is_admin:true,
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'admin-companies-list',
              component: () => import('./views/admin/clients/companies/List.vue'),
              meta: {
                is_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Clients',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Companies', active: true }
                ]
              }
            },
            {
              path: 'add',
              name: 'admin-companies-add',
              component: () => import('./views/admin/clients/companies/Add.vue'),
              meta: {
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Clients',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Companies', url: '/admin/clients/companies' },
                  { title: 'Add', active: true }
                ]
              }
            },
            {
              path: 'add-manual-payment',
              name: 'admin-companies-add-manual-payment',
              component: () => import('./views/admin/clients/companies/AddManualPayment.vue'),
              meta: {
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Clients',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Companies', url: '/admin/clients/companies' },
                  { title: 'Add Manual Payment', active: true }
                ]
              }
            },
            {
              path: 'edit/:id',
              name: 'admin-companies-edit',
              component: () => import('./views/admin/clients/companies/Edit.vue'),
              meta: {
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Clients',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Companies', url: '/admin/clients/companies' },
                  { title: 'Edit', active: true }
                ]
              }
            },
            {
              path: ':id/payment-history',
              name: 'admin-companies-payment-history',
              redirect: { name: 'admin-companies-payment-history-list' },
              component: () => import('./views/admin/clients/companies/paymentHistory/Index.vue'),
              meta: {
                requiresAuth: true,
                rule: 'editor',
              },
              children: [
                {
                  path: 'list',
                  name: 'admin-companies-payment-history-list',
                  component: () => import('./views/admin/clients/companies/paymentHistory/List.vue'),
                  meta: {
                    requiresAuth: true,
                    rule: 'editor',
                    pageTitle: 'Clients',
                    breadcrumb: [
                      { title: 'Home', url: '/' },
                      { title: 'Companies', url: '/admin/clients/companies' },
                      { title: 'Payment History', active: true }
                    ]
                  }
                }
              ]
            },
            {
              path: ':id/transaction-history',
              name: 'admin-companies-transaction-history',
              redirect: { name: 'admin-companies-transaction-history-list' },
              component: () => import('./views/admin/clients/companies/transactionHistory/Index.vue'),
              meta: {
                requiresAuth: true,
                rule: 'editor',
              },
              children: [
                {
                  path: 'list',
                  name: 'admin-companies-transaction-history-list',
                  component: () => import('./views/admin/clients/companies/transactionHistory/List.vue'),
                  meta: {
                    requiresAuth: true,
                    rule: 'editor',
                    pageTitle: 'Clients',
                    breadcrumb: [
                      { title: 'Home', url: '/' },
                      { title: 'Companies', url: '/admin/clients/companies' },
                      { title: 'Transaction History', active: true }
                    ]
                  }
                }
              ]
            },
            {
              path: ':id/invoice-history',
              name: 'admin-companies-invoice-history',
              redirect: { name: 'admin-companies-invoice-history-list' },
              component: () => import('./views/admin/clients/companies/invoiceHistory/Index.vue'),
              meta: {
                requiresAuth: true,
                rule: 'editor',
              },
              children: [
                {
                  path: 'list',
                  name: 'admin-companies-invoice-history-list',
                  component: () => import('./views/admin/clients/companies/invoiceHistory/List.vue'),
                  meta: {
                    requiresAuth: true,
                    rule: 'editor',
                    pageTitle: 'Clients',
                    breadcrumb: [
                      { title: 'Home', url: '/' },
                      { title: 'Companies', url: '/admin/clients/companies' },
                      { title: 'Invoice History', active: true }
                    ]
                  }
                }
              ]
            },
            {
              path: ':id/company-accounts',
              name: 'admin-companies-company-accounts',
              redirect: { name: 'admin-companies-company-accounts-list' },
              component: () => import('./views/admin/clients/companies/companyAccounts/Index.vue'),
              meta: {
                requiresAuth: true,
                rule: 'editor',
              },
              children: [
                {
                  path: 'list',
                  name: 'admin-companies-company-accounts-list',
                  component: () => import('./views/admin/clients/companies/companyAccounts/List.vue'),
                  meta: {
                    requiresAuth: true,
                    rule: 'editor',
                    pageTitle: 'Clients',
                    breadcrumb: [
                      { title: 'Home', url: '/' },
                      { title: 'Companies', url: '/admin/clients/companies' },
                      { title: 'Company Accounts', active: true }
                    ]
                  }
                },
                {
                  path: 'add',
                  name: 'admin-companies-company-accounts-add',
                  component: () => import('./views/admin/clients/companies/companyAccounts/Add.vue'),
                  meta: {
                    requiresAuth: true,
                    rule: 'editor',
                    pageTitle: 'Clients',
                    breadcrumb: [
                      { title: 'Home', url: '/' },
                      { title: 'Companies', url: '/admin/clients/companies' },
                      { title: 'Company Accounts', url: `/admin/clients/companies/:id/company-accounts/list`, name: 'admin-companies-company-accounts-list'},
                      { title: 'Add', active: true }
                    ]
                  }
                },
                {
                  path: 'edit/:user_id',
                  name: 'admin-companies-company-accounts-edit',
                  component: () => import('./views/admin/clients/companies/companyAccounts/Edit.vue'),
                  meta: {
                    requiresAuth: true,
                    rule: 'editor',
                    pageTitle: 'Clients',
                    breadcrumb: [
                      { title: 'Home', url: '/' },
                      { title: 'Companies', url: '/admin/clients/companies' },
                      { title: 'Company Accounts', url: {name: 'admin-companies-company-accounts-list'} },
                      { title: 'Edit', active: true }
                    ]
                  }
                }
              ]
            }
          ]
        },

        //Client ID Group
        {
          path: '/admin/caller/import',
          name: 'admin-caller-import',
          redirect: { name: 'admin-caller-import-list' },
          component: () => import('./views/admin/client-id-group/import-log/Index.vue'),
          meta: {
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'admin-caller-import-list',
              component: () => import('./views/admin/client-id-group/import-log/List.vue'),
              meta: {
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Client ID Group',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Import', active: true }
                ]
              }
            },
          ]
        },
        {
          path: '/admin/caller/caller-id',
          name: 'admin-caller-caller-id',
          redirect: { name: 'admin-caller-caller-id-list' },
          component: () => import('./views/admin/client-id-group/caller-id/Index.vue'),
          meta: {
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'admin-caller-caller-id-list',
              component: () => import('./views/admin/client-id-group/caller-id/List.vue'),
              meta: {
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Client ID Group',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Caller ID', active: true }
                ]
              }
            },
          ]
        },
        {
          path: '/admin/caller/caller-id/import',
          name: 'admin-caller-caller-id-import',
          redirect: { name: 'admin-caller-caller-id-import' },
          component: () => import('./views/admin/client-id-group/caller-id/import/Index.vue'),
          meta: {
            admin:true,
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'admin-caller-caller-id-import',
              component: () => import('./views/admin/client-id-group/caller-id/import/List.vue'),
              meta: {
                admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Caller ID',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Import', active: true }
                ]
              },
            },
          ]
        },
        // ===============================================================
        // Clients Users
        // ===============================================================
        {
          path: '/admin/clients/users',
          name: 'admin-users',
          redirect: { name: 'admin-users-list' },
          component: () => import('./views/admin/clients/users/Index.vue'),
          meta: {
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'admin-users-list',
              component: () => import('./views/admin/clients/users/List.vue'),
              meta: {
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Clients',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Users', active: true }
                ]
              }
            },
            {
              path: 'edit/:id',
              name: 'admin-users-edit',
              component: () => import('./views/admin/clients/users/Edit.vue'),
              meta: {
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Clients',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Users', url: '/admin/clients/users/list' },
                  { title: 'Edit', active: true }
                ]
              }
            }
          ]
        },

        // ===============================================================
        // SMSC Connections
        // ===============================================================
        {
          path: '/admin/smsc-connection',
          name: 'admin-smsc-connections',
          redirect: { name: 'admin-smsc-connections-list' },
          component: () => import('./views/admin/smsc-connections/Index.vue'),
          meta: {
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'admin-smsc-connections-list',
              component: () => import('./views/admin/smsc-connections/List.vue'),
              meta: {
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'SMSC Connections',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'SMSC Connections', active: true }
                ]
              }
            },
            {
              path: 'add',
              name: 'admin-smsc-connections-add',
              component: () => import('./views/admin/smsc-connections/Add.vue'),
              meta: {
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'SMSC Connections',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'SMSC Connections', url: '/admin/smsc-connection' },
                  { title: 'Add', active: true }
                ]
              }
            },
            {
              path: 'edit/:id',
              name: 'admin-smsc-connections-edit',
              component: () => import('./views/admin/smsc-connections/Edit.vue'),
              meta: {
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'SMSC Connections',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'SMSC Connections', url: '/admin/smsc-connection' },
                  { title: 'Edit', active: true }
                ]
              }
            }
          ]
        },

        // ===============================================================
        // Filters
        // ===============================================================
        {
          path: '/admin/filter',
          name: 'admin-filters',
          redirect: { name: 'admin-filters-list' },
          component: () => import('./views/admin/filters/Index.vue'),
          meta: {
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'admin-filters-list',
              component: () => import('./views/admin/filters/List.vue'),
              meta: {
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Filters',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Filters', active: true }
                ]
              },
            }
          ]
        },

        // ===============================================================
        // Vendors
        // ===============================================================
        {
          path: '/admin/vendor',
          name: 'admin-vendors',
          redirect: { name: 'admin-vendors-list' },
          component: () => import('./views/admin/vendors/Index.vue'),
          meta: {
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'admin-vendors-list',
              component: () => import('./views/admin/vendors/List.vue'),
              meta: {
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Vendors',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Vendors', active: true }
                ]
              },
            },
            {
              path: 'add',
              name: 'admin-vendors-add',
              component: () => import('./views/admin/vendors/Add.vue'),
              meta: {
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Vendors',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Vendors', url: '/admin/vendor' },
                  { title: 'Add', active: true }
                ]
              },
            },
            {
              path: 'edit/:id',
              name: 'admin-vendors-edit',
              component: () => import('./views/admin/vendors/Edit.vue'),
              meta: {
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Vendors',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Vendors', url: '/admin/vendor' },
                  { title: 'Edit', active: true }
                ]
              },
            },
            {
              path: ':id/did',
              name: 'admin-vendors-did',
              redirect: { name: 'admin-vendors-did-list' },
              component: () => import('./views/admin/vendors/did/Index.vue'),
              meta: {
                requiresAuth: true,
                rule: 'editor',
              },
              children: [
                {
                  path: 'list',
                  name: 'admin-vendors-did-list',
                  component: () => import('./views/admin/vendors/did/List.vue'),
                  meta: {
                    requiresAuth: true,
                    rule: 'editor',
                    pageTitle: 'Vendors',
                    breadcrumb: [
                      { title: 'Home', url: '/' },
                      { title: 'Vendors', url: '/admin/vendor' },
                      { title: 'DID', active: true }
                    ]
                  }
                },
                {
                  path: 'add',
                  name: 'admin-vendors-did-add',
                  component: () => import('./views/admin/vendors/did/Add.vue'),
                  meta: {
                    requiresAuth: true,
                    rule: 'editor',
                    pageTitle: 'Vendors',
                    breadcrumb: [
                      { title: 'Home', url: '/' },
                      { title: 'Vendors', url: '/admin/vendor' },
                      { title: 'DID', url: '/admin/vendor/:id/did/list' },
                      { title: 'Add', active: true }
                    ]
                  }
                },
                {
                  path: 'edit/:did',
                  name: 'admin-vendors-did-edit',
                  component: () => import('./views/admin/vendors/did/Edit.vue'),
                  meta: {
                    requiresAuth: true,
                    rule: 'editor',
                    pageTitle: 'Vendors',
                    breadcrumb: [
                      { title: 'Home', url: '/' },
                      { title: 'Vendors', url: '/admin/vendor' },
                      { title: 'DID', url: '/admin/vendor/:id/did/list' },
                      { title: 'Edit', active: true }
                    ]
                  }
                }
              ]
            },
            {
              path: ':id/smsc-bind',
              name: 'admin-vendors-smsc-bind',
              redirect: { name: 'admin-vendors-smsc-bind-list' },
              component: () => import('./views/admin/vendors/smscBind/Index.vue'),
              meta: {
                requiresAuth: true,
                rule: 'editor',
              },
              children: [
                {
                  path: 'list',
                  name: 'admin-vendors-smsc-bind-list',
                  component: () => import('./views/admin/vendors/smscBind/List.vue'),
                  meta: {
                    requiresAuth: true,
                    rule: 'editor',
                    pageTitle: 'Vendors',
                    breadcrumb: [
                      { title: 'Home', url: '/' },
                      { title: 'Vendors', url: '/admin/vendor' },
                      { title: 'SMSC Bind', active: true}
                    ]
                  }
                },
                {
                  path: 'add',
                  name: 'admin-vendors-smsc-bind-add',
                  component: () => import('./views/admin/vendors/smscBind/Add.vue'),
                  meta: {
                    requiresAuth: true,
                    rule: 'editor',
                    pageTitle: 'Vendors',
                    breadcrumb: [
                      { title: 'Home', url: '/' },
                      { title: 'Vendors', url: '/admin/vendor' },
                      { title: 'SMSC Bind', url: {name: 'admin-vendors-smsc-bind-list'} },
                      { title: 'Add', active: true }
                    ]
                  }
                },
                {
                  path: 'edit/:prod_id',
                  name: 'admin-vendors-smsc-bind-edit',
                  component: () => import('./views/admin/vendors/smscBind/Edit.vue'),
                  meta: {
                    requiresAuth: true,
                    rule: 'editor',
                    pageTitle: 'Vendors',
                    breadcrumb: [
                      { title: 'Home', url: '/' },
                      { title: 'Vendors', url: '/admin/vendor' },
                      { title: 'SMSC Bind', url: '/admin/vendor/:id/did/list' },
                      { title: 'Edit', active: true }
                    ]
                  }
                },
                {
                  path: ':rate_id/rate-add',
                  name: 'admin-vendors-smsc-bind-rate-add',
                  component: () => import('./views/admin/vendors/smscBind/AddRate.vue'),
                  meta: {
                    requiresAuth: true,
                    rule: 'editor',
                    pageTitle: 'Vendors',
                    breadcrumb: [
                      { title: 'Home', url: '/' },
                      { title: 'Vendors', url: '/admin/vendor' },
                      { title: 'SMSC Bind', url: '/admin/vendor/:id/did/list' },
                      { title: 'Add Rate', active: true }
                    ]
                  }
                }
              ]
            },
            {
              path: ':id/rate-deck',
              name: 'admin-vendors-rate-deck',
              redirect: { name: 'admin-vendors-rate-deck-list' },
              component: () => import('./views/admin/vendors/rateDeck/Index.vue'),
              meta: {
                requiresAuth: true,
                rule: 'editor',
              },
              children: [
                {
                  path: 'list',
                  name: 'admin-vendors-rate-deck-list',
                  component: () => import('./views/admin/vendors/rateDeck/List.vue'),
                  meta: {
                    requiresAuth: true,
                    rule: 'editor',
                    pageTitle: 'Vendors',
                    breadcrumb: [
                      { title: 'Home', url: '/' },
                      { title: 'Vendors', url: '/admin/vendor' },
                      { title: 'Rate Deck', active: true }
                    ]
                  }
                },
                {
                  path: 'add-edit-prefix',
                  name: 'admin-vendors-rate-deck-add-prefix',
                  component: () => import('./views/admin/vendors/rateDeck/components/add-edit-prefix.vue'),
                  meta: {
                    requiresAuth: true,
                    rule: 'editor',
                    pageTitle: 'Vendors',
                    breadcrumb: [
                      { title: 'Home', url: '/' },
                      { title: 'Vendors', url: '/admin/vendor' },
                      { title: 'Rate Deck', url: '/admin/vendor' },
                      { title: 'Change', active: true }
                    ]
                  }
                },
                {
                  path: 'add-edit-mncmcc',
                  name: 'admin-vendors-rate-deck-add-mncmcc',
                  component: () => import('./views/admin/vendors/rateDeck/components/add-edit-mncmcc.vue'),
                  meta: {
                    requiresAuth: true,
                    rule: 'editor',
                    pageTitle: 'Vendors',
                    breadcrumb: [
                      { title: 'Home', url: '/' },
                      { title: 'Vendors', url: '/admin/vendor' },
                      { title: 'Rate Deck', url: '/admin/vendor' },
                      { title: 'Change', active: true }
                    ]
                  }
                }
              ]
            }
          ]
        },
        {
          path: '/admin/vendor/rate-import',
          name: 'admin-vendors-rate-import',
          redirect: { name: 'admin-vendors-rate-import-list' },
          component: () => import('./views/admin/vendors/rate-import/Index.vue'),
          meta: {
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'admin-vendors-rate-import-list',
              component: () => import('./views/admin/vendors/rate-import/List.vue'),
              meta: {
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Vendors',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Rate Import Log', active: true }
                ]
              },
            },
          ]
        },
        // ===============================================================
        // Usage report
        // ===============================================================
        {
          path: '/admin/usage-report',
          name: 'admin-usage-report',
          redirect: { name: 'admin-usage-report-list' },
          component: () => import('./views/admin/usage-report/Index.vue'),
          meta: {
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'admin-usage-report-list',
              component: () => import('./views/admin/usage-report/List.vue'),
              meta: {
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Usage Report',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Usage Report', active: true }
                ]
              },
            }
          ]
        },

        // ===============================================================
        // Bulk Report
        // ===============================================================
        {
          path: '/admin/bulk-report',
          name: 'admin-bulk-report',
          redirect: { name: 'admin-bulk-report-list' },
          component: () => import('./views/admin/bulk-report/Index.vue'),
          meta: {
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'admin-bulk-report-list',
              component: () => import('./views/admin/bulk-report/List.vue'),
              meta: {
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Bulk Report',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Bulk Report', active: true }
                ]
              },
            }
          ]
        },

        // ===============================================================
        // Default rate
        // ===============================================================
        {
          path: '/admin/rate',
          name: 'admin-default-rate',
          redirect: { name: 'admin-default-rate-list' },
          component: () => import('./views/admin/rate/Index.vue'),
          meta: {
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'admin-default-rate-list',
              component: () => import('./views/admin/rate/List.vue'),
              meta: {
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Default Rate',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Default Rate', active: true }
                ]
              },
            }
          ]
        },
        // =============================================================================
        // Balance Log
        // =============================================================================
        {
          path: '/admin/balance-log',
          name: 'admin-balance-log',
          redirect: { name: 'admin-balance-log-list' },
          component: () => import('./views/admin/rate/Index.vue'),
          meta: {
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'admin-balance-log-list',
              component: () => import('./views/admin/Balance/List.vue'),
              meta: {
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Balance Log',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Balance Log', active: true }
                ]
              },
            }
          ]
        },
        // =============================================================================
        // Pages Routes
        // =============================================================================
        {
          path: '/pages/profile',
          name: 'page-profile',
          component: () => import('@/views/pages/user-profile/Userprofile.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Pages' },
              { title: 'User Profile', active: true }
            ],
            pageTitle: 'Profile',
            rule: 'editor'
          }
        },
        {
          path: '/pages/user-settings',
          name: 'page-user-settings',
          component: () => import('@/views/pages/user-settings/UserSettings.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Pages' },
              { title: 'User Settings', active: true }
            ],
            pageTitle: 'Settings',
            rule: 'editor'
          }
        },
        {
          path: '/pages/setting',
          name: 'page-settings',
          component: () => import('@/views/pages/user-settings/Setting.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Pages' },
              { title: 'User Settings', active: true }
            ],
            pageTitle: 'Settings',
            rule: 'editor'
          }
        },
        {
          path: '/pages/topup',
          name: 'page-topup',
          component: () => import('@/views/pages/user-settings/Topup.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Top-Up' }
            ],
            pageTitle: 'Top-Up',
            rule: 'editor'
          }
        },
        {
          path: '/pages/faq',
          name: 'page-faq',
          component: () => import('@/views/pages/Faq.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Pages' },
              { title: 'FAQ', active: true }
            ],
            pageTitle: 'FAQ',
            rule: 'editor'
          }
        },
        {
          path: '/pages/knowledge-base',
          name: 'page-knowledge-base',
          component: () => import('@/views/pages/KnowledgeBase.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Pages' },
              { title: 'KnowledgeBase', active: true }
            ],
            pageTitle: 'KnowledgeBase',
            rule: 'editor'
          }
        },
        {
          path: '/pages/knowledge-base/category',
          name: 'page-knowledge-base-category',
          component: () => import('@/views/pages/KnowledgeBaseCategory.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Pages' },
              { title: 'KnowledgeBase', url: '/pages/knowledge-base' },
              { title: 'Category', active: true }
            ],
            parent: 'page-knowledge-base',
            rule: 'editor'
          }
        },
        {
          path: '/pages/knowledge-base/category/question',
          name: 'page-knowledge-base-category-question',
          component: () => import('@/views/pages/KnowledgeBaseCategoryQuestion.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Pages' },
              { title: 'KnowledgeBase', url: '/pages/knowledge-base' },
              { title: 'Category', url: '/pages/knowledge-base/category' },
              { title: 'Question', active: true }
            ],
            parent: 'page-knowledge-base',
            rule: 'editor'
          }
        },
        {
          path: '/pages/search',
          name: 'page-search',
          component: () => import('@/views/pages/Search.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Pages' },
              { title: 'Search', active: true }
            ],
            pageTitle: 'Search',
            rule: 'editor'
          }
        },
        {
          path: '/pages/invoice',
          name: 'page-invoice',
          component: () => import('@/views/pages/Invoice.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Pages' },
              { title: 'Invoice', active: true }
            ],
            pageTitle: 'Invoice',
            rule: 'editor'
          }
        },
        // COMPANY ADMIN
        {
          path: '/',
          name: 'company_admin',
          redirect: '/company-admin/dashboard',
          meta: {
            is_company_admin:true,
            requiresAuth: true,
            rule: 'admin'
          }
        },
        {
          path: "/company-admin/dashboard",
          name: 'company-admin-dashboard',
          component: () => import('./views/company-admin/dashboard/company_admin_dashboard.vue'),
          meta: {
            is_company_admin: true,
            requiresAuth: true,
            title: 'Dashboard',
            rule: 'admin'
          },
        },
        // ===============================================================
        // Profile.vue
        // ===============================================================

        {
          path: '/company-admin/profile',
          name: 'Company-Admin-Profile',
          component: () => import('./views/company-admin/Profile.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Profile' }
            ],
            pageTitle: 'Profile',
            rule: 'editor'
          }
        },

        {
          path: '/company_admin/payment_history',
          name: 'Company_admin_payment_history',
          redirect: { name: 'Company_admin_payment_history' },
          component: () => import('./views/company-admin/payment_history/index.vue'),
          meta: {
            is_company_admin:true,
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: '',
              name: 'Company_admin_payment_history',
              component: () => import('./views/company-admin/payment_history/index.vue'),
              meta: {
                is_company_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Payment History',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Payment History', active: true }
                ],
              }
            },
          ]
        },
        {
          path: '/company_admin/dids',
          name: 'Company_admin_DIDs',
          redirect: { name: 'Company_admin_DIDs_list' },
          component: () => import('./views/company-admin/dids/Index'),
          meta: {
            is_company_admin:true,
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'Company_admin_DIDs_list',
              component: () => import('./views/company-admin/dids/List'),
              meta: {
                is_company_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'DIDs',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'DIDs', active: true }
                ],
              }
            },
            {
              path: 'add',
              name: 'Company_admin_DIDs_add',
              component: () => import('./views/company-admin/dids/Add.vue'),
              meta: {
                is_company_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Import from Opentact',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Import from Opentact', active: true }
                ],
              }
            },
            {
              path: 'bydid',
              name: 'Company_admin_DIDs_ByDid',
              component: () => import('./views/company-admin/dids/ByDid'),
              meta: {
                is_company_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'DIDs',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'DIDs ByDid', active: true }
                ],
              }
            },
            {
              path: 'edit',
              name: 'Company_admin_DIDs_edit',
              component: () => import('./views/company-admin/dids/Edit'),
              meta: {
                is_company_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'DIDs',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'DIDs Edit', active: true }
                ],
              }
            },
          ]
        },
        {
          path: '/company_admin/user',
          name: 'Company_admin_user',
          redirect: { name: 'Company_admin_user_list' },
          component: () => import('./views/company-admin/company_users/Index'),
          meta: {
            is_company_admin:true,
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'Company_admin_user_list',
              component: () => import('./views/company-admin/company_users/List'),
              meta: {
                is_company_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Users',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Users', active: true }
                ],
              }
            },
            {
              path: 'add',
              name: 'Company_admin_user_add',
              component: () => import('./views/company-admin/dids/Add.vue'),
              meta: {
                is_company_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Users',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'User Add', active: true }
                ],
              }
            },
            {
              path: 'edit',
              name: 'Company_admin_user_edit',
              component: () => import('./views/company-admin/company_users/Users/Edit.vue'),
              meta: {
                is_company_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Users',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'User Edit', active: true }
                ],
              }
            },
          ]
        },
        {
          path: '/company_admin/users/users',
          name: 'Company_admin_users',
          redirect: { name: 'Company_admin_users_list' },
          component: () => import('./views/company-admin/company_users/Users/Index'),
          meta: {
            is_company_admin:true,
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'Company_admin_users_list',
              component: () => import('./views/company-admin/company_users/Users/List'),
              meta: {
                is_company_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Users',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Users/Users', active: true }
                ],
              }
            },
            /*{
              path: 'add',
              name: 'Company_admin_users_add',
              component: () => import('./views/company-admin/dids/Add.vue'),
              meta: {
                is_company_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Import from Opentact',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Import from Opentact', active: true }
                ],
              }
            },*/
          ]
        },
        {
          path: '/company_admin/send_sms',
          name: 'Company_admin_send_sms',
          redirect: { name: 'Company_admin_payment_history' },
          component: () => import('./views/company-admin/send_sms'),
          meta: {
            is_company_admin:true,
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: '',
              name: 'Company_admin_send_sms',
              component: () => import('./views/company-admin/send_sms'),
              meta: {
                is_company_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Send SMS',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Send SMS', active: true }
                ],
              }
            },
          ]
        },
       /* {
          path: '/company_admin/ani_group',
          name: 'Company_admin_ani_group',
          redirect: { name: 'Company_admin_ani_group' },
          component: () => import('./views/company-admin/ani_group/index.vue'),
          meta: {
            is_company_admin:true,
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: '',
              name: 'Company_admin_ani_group',
              component: () => import('./views/company-admin/ani_group/index.vue'),
              meta: {
                is_company_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'ANI Group',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'ANI Group', active: true }
                ],
              }
            },
          ]
        },*/
        {
          path: '/company_admin/message',
          name: 'Company_admin_mesaage',
          redirect: { name: 'company_admin_message' },
          component: () => import('./views/company-admin/message/Index.vue'),
          meta: {
            is_company_admin:true,
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'chat',
              name: 'company_admin_message',
              component: () => import('./views/company-admin/message/Chat.vue'),
              meta: {
                is_company_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Message',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Message', active: true }
                ],
              }
            },
          ]
        },
        // {
        //   path: '/company-admin/billing',
        //   name: 'company-admin-billing',
        //   redirect: { name: 'company-admin-billing-invoice-list' }
        // },
        // {
        //   path: '/company-admin/billing/invoice',
        //   name: 'company-admin-billing-invoice',
        //   redirect: { name: 'company-admin-billing-invoice-list' },
        //   component: () => import('./views/company-admin/billing/invoice/Index.vue'),
        //   meta: {
        //     is_admin:true,
        //     requiresAuth: true,
        //     rule: 'editor'
        //   },
        //   children: [

        //   ]
        // },

        // // ===============================================================
        // // Billing Payment
        // // ===============================================================
        // {
        //   path: '/company-admin/billing/payment',
        //   name: 'company-admin-billing-payment',
        //   redirect: { name: 'company-admin-billing-payment-list' },
        //   component: () => import('./views/company-admin/billing/payment/Index.vue'),
        //   meta: {
        //     is_admin:true,
        //     requiresAuth: true,
        //     rule: 'editor'
        //   },
        //   children: [

        //   ]
        // },
        // {
        //   path:'/company_admin_ContactList',
        //   name: 'company_admin_ContactList',
        //   component: () => import('./views/company-admin/Contact/company_admin_ContactList.vue'),
        //   meta: {
        //     rule: 'editor'
        //   }
        // },

        // // ===============================================================
        // // Billing Invoice
        // // ===============================================================


        {
          path: '/company-admin/billing',
          name: 'company-admin-billing',
          // redirect: { name: 'company-admin-billing-invoice-list' }
        },
        {
          path: '/company-admin/billing/invoice',
          name: 'company-admin-billing-invoice',
          redirect: { name: 'company-admin-billing-invoice-list' },
          component: () => import('./views/company-admin/billing/invoice/index.vue'),
          meta: {
            is_company_admin:true,
            requiresAuth: true,
            rule: 'editor',
          },
          children: [
            {
              path: 'list',
              name: 'company-admin-billing-invoice-list',
              component: () => import('./views/company-admin/billing/invoice/List.vue'),
              meta: {
                is_company_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Billing',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Invoice', active: true }
                ]
              },
            },
            {
              path: 'add',
              name: 'company-admin-billing-invoice-add',
              component: () => import('./views/company-admin/billing/invoice/Add.vue'),
              meta: {
                is_company_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Billing',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Invoice', url: '/company_admin/billing/invoice/list' },
                  { title: 'Add', active: true }
                ]
              },
            }
          ]
        },
        // =============================================================================
        // Company Admin Reporting
        // =============================================================================
        {
          path: '/company_admin/reporting/destination-report',
          name: 'company-admin-reporting-destination-report',
          redirect: { name: 'company-admin-reporting-destination-report-list' },
          component: () => import('./views/company-admin/reporting/Destination Report/Index.vue'),
          meta: {
            is_company_admin:true,
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'company-admin-reporting-destination-report-list',
              component: () => import('./views/company-admin/reporting/Destination Report/List.vue'),
              meta: {
                is_company_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Reporting',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Destination Report', active: true }
                ]
              },
            },
          ]
        },
        // =============================================================================
        //
        // =============================================================================


        {
          path: '/company_admin/contact_list',
          name: 'Company_admin_contact',
          redirect: { name: 'company_admin_contact' },
          component: () => import('./views/company-admin/Contact/Index.vue'),
          meta: {
            is_company_admin:true,
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'company_admin_contact',
              component: () => import('./views/company-admin/Contact/List.vue'),
              meta: {
                is_company_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Contact List',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Contact List', active: true }
                ],
              }
            },
            {
              path: 'create',
              name: 'create-company_admin_contact',
              component: () => import('./views/company-admin/Contact/Create.vue'),
              meta: {
                is_company_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Contact Create',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Contact Create', active: true }
                ],
              }
            },
          ]
        },
        {
          path: '/company_admin/user_page',
          name: 'Company_admin_user',
          redirect: { name: 'company_admin_user' },
          component: () => import('./views/company-admin/user/Index.vue'),
          meta: {
            is_company_admin:true,
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'company_admin_user',
              component: () => import('./views/company-admin/user/List.vue'),
              meta: {
                is_company_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'User',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'User', active: true }
                ],
              }
            },
          ]
        },
        {
          path: '/company_admin/bulk_report',
          name: 'company_admin-bulk-report',
          redirect: { name: 'company_admin-bulk-report-list' },
          component: () => import('./views/company-admin/bulk-report/Index.vue'),
          meta: {
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'company_admin-bulk-report-list',
              component: () => import('./views/company-admin/bulk-report/List.vue'),
              meta: {
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Bulk Report',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Bulk Report', active: true }
                ]
              },
            }
          ]
        },
        //Template
        {
          path: '/comany_admin/template',
          name: 'company_admin_template',
          redirect: { name: 'company_admin_template_auto_list' }
        },
        {
          path: '/company_admin/template/auto',
          name: 'company_admin-template-auto',
          redirect: { name: 'company-admin-template-auto-list' },
          component: () => import('./views/company-admin/AutoResponding/Index.vue'),
          meta: {
            is_company_admin:true,
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'company-admin-template-auto-list',
              component: () => import('./views/company-admin/AutoResponding/List.vue'),
              meta: {
                is_company_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Template',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Auto Responding', active: true }
                ]
              },
            },
          ]
        },

        {
          path: '/company_admin/template/tips',
          name: 'company_admin-template-tips',
          redirect: { name: 'company-admin-template-tips-list' },
          component: () => import('./views/company-admin/Tips/Index.vue'),
          meta: {
            is_company_admin:true,
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'company-admin-template-tips-list',
              component: () => import('./views/company-admin/Tips/List.vue'),
              meta: {
                is_company_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Template',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Tips', active: true }
                ]
              },
            },
          ]
        },

        {
          path: '/company_admin/template/sms',
          name: 'company_admin-template-sms',
          redirect: { name: 'company-admin-template-sms-list' },
          component: () => import('./views/company-admin/SMSTemplate/Index.vue'),
          meta: {
            is_company_admin:true,
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'company-admin-template-sms-list',
              component: () => import('./views/company-admin/SMSTemplate/List.vue'),
              meta: {
                is_company_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Template',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'SMS Template', active: true }
                ]
              },
            },
            {
              path: 'add',
              name: 'company-admin-sms-template-add',
              component: () => import('./views/company-admin/SMSTemplate/Add.vue'),
              meta: {
                is_company_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Template ',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'SMS Template'},
                  { title: 'Add', active: true }
                ]
              },
            },
            {
              path: 'edit/:id',
              name: 'company-admin-template-edit',
              component: () => import('./views/company-admin/SMSTemplate/Edit.vue'),
              meta: {
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'SMSTemplate',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Template', url: '/company-admin/template/sms' },
                  { title: 'Edit', active: true }
                ]
              },
            },
          ]
        },
        //Campaign
        {
          path: '/company_admin/campaign/contact',
          name: 'company_admin-campaign-contact',
          redirect: { name: 'company-admin-campaign-contact-list' },
          component: () => import('./views/company-admin/campaign/contact-group/Index.vue'),
          meta: {
            is_company_admin:true,
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'company-admin-campaign-contact-list',
              component: () => import('./views/company-admin/campaign/contact-group/List.vue'),
              meta: {
                is_company_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Campaign',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Contact Group', active: true }
                ]
              },
            },
          ]
        },
        {
          path: '/company_admin/campaign/caller-id',
          name: 'company_admin-campaign-caller-id',
          redirect: { name: 'company-admin-campaign-caller-id-list' },
          component: () => import('./views/company-admin/campaign/caller-id/Index.vue'),
          meta: {
            is_company_admin:true,
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'company-admin-campaign-caller-id-list',
              component: () => import('./views/company-admin/campaign/caller-id/List.vue'),
              meta: {
                is_company_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Campaign',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Caller ID', active: true }
                ]
              },
            },
          ]
        },
        {
          path: '/company_admin/campaign/caller-id/import',
          name: 'company_admin-campaign-caller-id-import',
          redirect: { name: 'company-admin-campaign-caller-id-import' },
          component: () => import('./views/company-admin/campaign/caller-id/import/Index.vue'),
          meta: {
            is_company_admin:true,
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'import',
              name: 'company-admin-campaign-caller-id-import',
              component: () => import('./views/company-admin/campaign/caller-id/import/List.vue'),
              meta: {
                is_company_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Caller ID',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Import', active: true }
                ]
              },
            },
          ]
        },
        {
          path: '/company_admin/campaign/bulk',
          name: 'company_admin-campaign-bulk',
          redirect: { name: 'company-admin-campaign-bulk-list' },
          component: () => import('./views/company-admin/campaign/bulk-sms/Index.vue'),
          meta: {
            is_company_admin:true,
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'company-admin-campaign-bulk-list',
              component: () => import('./views/company-admin/campaign/bulk-sms/List.vue'),
              meta: {
                is_company_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Campaign',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Bulk SMS', active: true }
                ]
              },
            },
          ]
        },
        //Number Listing
        {
          path: '/comany_admin/number_listing',
          name: 'company_admin_number_listing',
          redirect: { name: 'company_admin_number_listing_did_list' }
        },
        {
          path: '/company_admin/number_listing/did',
          name: 'company-admin-number-listing-did',
          redirect: { name: 'company-admin-number-listing-did-list' },
          component: () => import('./views/company-admin/number-listing/did/Index.vue'),
          meta: {
            is_company_admin:true,
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'company-admin-number-listing-did-list',
              component: () => import('./views/company-admin/number-listing/did/List.vue'),
              meta: {
                is_company_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Number Listing',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'DID', active: true }
                ]
              },
            },
            {
              path: 'buy-number',
              name: 'company-admin-number-listing-did-buy-number',
              component: () => import('./views/company-admin/user/List.vue'),
              meta: {
                is_company_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Number Listing',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'DID', active: true }
                ],
              }
            }
          ]
        },
        {
          path: '/company_admin/number_listing/ani',
          name: 'company-admin-number-listing-ani',
          redirect: { name: 'company-admin-number-listing-ani-list' },
          component: () => import('./views/company-admin/number-listing/ani-pool/Index.vue'),
          meta: {
            is_company_admin:true,
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'company-admin-number-listing-ani-list',
              component: () => import('./views/company-admin/number-listing/ani-pool/List.vue'),
              meta: {
                is_company_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Number Listing',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'ANI Pool', active: true }
                ]
              },
            },
          ]
        },
        //Report
        {
          path: '/company_admin/report/outboundsmslog',
          name: 'company-admin-reprt-outboundsmslog',
          redirect: { name: 'company-admin-report-outboundsmslog-list' },
          component: () => import('./views/company-admin/report/outboundsmslog/Index.vue'),
          meta: {
            is_company_admin:true,
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'company-admin-report-outboundsmslog-list',
              component: () => import('./views/company-admin/report/outboundsmslog/List.vue'),
              meta: {
                is_company_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Report',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Outbound SMS Log', active: true }
                ]
              },
            },
          ]
        },
        {
          path: '/company_admin/report/inboundsmslog',
          name: 'company-admin-reprt-inboundsmslog',
          redirect: { name: 'company-admin-report-inboundsmslog-list' },
          component: () => import('./views/company-admin/report/inboundsmslog/Index.vue'),
          meta: {
            is_company_admin:true,
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'company-admin-report-inboundsmslog-list',
              component: () => import('./views/company-admin/report/inboundsmslog/List.vue'),
              meta: {
                is_company_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Report',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Inbound SMS Log', active: true }
                ]
              },
            },
          ]
        },
        {
          path: '/company_admin/log/outboundsmslog',
          name: 'company-admin-log-outboundsmslog',
          redirect: { name: 'company-admin-log-outboundsmslog-list' },
          component: () => import('./views/company-admin/smslog/outbound/Index.vue'),
          meta: {
            is_company_admin:true,
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'company-admin-log-outboundsmslog-list',
              component: () => import('./views/company-admin/smslog/outbound/List.vue'),
              meta: {
                is_company_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Outbound',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Outbound SMS Log', active: true }
                ]
              },
            },
          ]
        },
        {
          path: '/company_admin/log/inboundsmslog',
          name: 'company-admin-log-inboundsmslog',
          redirect: { name: 'company-admin-log-inboundsmslog-list' },
          component: () => import('./views/company-admin/smslog/inbound/Index.vue'),
          meta: {
            is_company_admin:true,
            requiresAuth: true,
            rule: 'editor'
          },
          children: [
            {
              path: 'list',
              name: 'company-admin-log-inboundsmslog-list',
              component: () => import('./views/company-admin/smslog/inbound/List.vue'),
              meta: {
                is_company_admin:true,
                requiresAuth: true,
                rule: 'editor',
                pageTitle: 'Inbound',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Inbound SMS Log', active: true }
                ]
              },
            },
          ]
        },
        //RESELLER
        {
          path: '/',
          name: 'reseller',
          redirect: '/reseller/dashboard',
          meta: {
            is_reseller:true,
            requiresAuth: true,
            rule: 'admin'
          }
        },
        {
          path: "/reseller/dashboard",
          name: 'reseller-dashboard',
          component: () => import('./views/reseller/reseller_dashboard/resellerdashboard.vue'),
          meta: {
            is_reseller: true,
            requiresAuth: true,
            title: 'Dashboard',
            rule: 'editor'
          },
        },
        // {
        //   path: '/reseller/company',
        //   name: 'reseller-companies',
        //   component: () => import('@/views/reseller/company/company_list.vue'),
        //   meta: {
        //     is_reseller: true,
        //     requiresAuth: true,
        //     title: 'User',
        //     rule: 'editor'
        //   }
        // },
        // {
        //   path: '/reseller/company/add',
        //   name: 'reseller-companies-add',
        //   component: () => import('@/views/reseller/company/add.vue'),
        //   meta: {
        //     rule: 'reseller',
        //     no_scroll: true
        //   }
        // },
        // {
        //   path: '/reseller/company/:company_uuid',
        //   name: 'reseller-companies-details',
        //   component: () => import('@/views/reseller/company/details/company-details.vue'),
        //   meta: {
        //     rule: 'reseller'
        //   }
        // },
        {
          path: '/reseller/user',
          name: 'reseller-user',
          component: () => import('@/views/reseller/reseller_companyuser/reseller_companyuser.vue'),
          meta: {
            is_reseller: true,
            requiresAuth: true,
            title: 'ANI Pool',
            rule: 'editor',

          },
      },
        {
          path: '/reseller/anipool',
          name: 'reseller-anipool',
          component: () => import('./views/reseller/reseller_anipool/anipool.vue'),
          meta: {
            is_reseller: true,
            requiresAuth: true,
            title: 'ANI Pool',
            rule: 'editor'
          },
        },
        {
          path: '/reseller/anipool/numlist',
          name: 'reseller-anipool-numberlist',
          component: () => import('@/views/reseller/reseller_anipool/view/numlist.vue'),
          meta: {
            is_reseller: true,
            requiresAuth: true,
            title: 'ANI Pool',
            rule: 'editor'
          },
        },
        {
          path: '/reseller/anipool/addnum',
          name: 'reseller-anipool-addnumber',
          component: () => import('@/views/reseller/reseller_anipool/addnum.vue'),
          meta: {
            rule: 'reseller',
            no_scroll: true
          }
        },
        {
          path: '/reseller/anipool/addnum/buynum',
          name: 'reseller-buynumber',
          component: () => import('@/views/reseller/reseller_anipool/buyNumber.vue'),
          meta: {
            rule: 'reseller',
            no_scroll: true
          }
        },
        {
          path: '/reseller/invoice',
          name: 'reseller-invoice',
          component: () => import('./views/reseller/reseller_invoice/reseller_invoice.vue'),
          meta: {
            is_reseller: true,
            requiresAuth: true,
            title: 'ANI Pool',
            rule: 'editor'
          },
          // meta: {
          //   breadcrumb: [
          //     { title: 'Home', url: '/' },
          //     { title: 'Reseller' },
          //     { title: 'invoices', active: true }
          //   ],
          //   pageTitle: 'Invoice',
          //   rule: 'reseller'
          // }
        },
        {
          path: '/reseller/invoice/1',
          name: 'reseller-invoice-details',
          component: () => import('./views/reseller/reseller_invoice/invoiceDetails.vue'),
          meta: {
            rule: 'reseller'
          }
        },
        {
          path: '/reseller/payment',
          name: 'payment',
          component: () => import('./views/reseller/payment/payment.vue'),
          meta: {
            is_reseller: true,
            requiresAuth: true,
            title: 'Payment',
            rule: 'editor'
          },
          // meta: {
          //   breadcrumb: [
          //     { title: 'Home', url: '/' },
          //     { title: 'Reseller' },
          //     { title: 'Payment', active: true }
          //   ],
          //   pageTitle: 'ResellerPayment',
          //   rule: 'reseller'
          // }
        },
        {
          path: '/reseller/profile',
          name: 'reseller-profile',
          component: () => import('@/views/reseller/reseller_profile/reseller_profile.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'User' },
              { title: 'Profile', active: true }
            ],
            pageTitle: 'Reseller Profile',
            rule: 'reseller'
          }
        },


        // COMUSER
        {
          path: '/',
          name: 'comuser',
          redirect: '/comuser/dashboard',
          meta: {
            is_company_admin:true,
            requiresAuth: true,
            rule: 'editor'
          }
        },
        {
          path: "/comuser/dashboard",
          name: 'comuser-dashboard',
          component: () => import('./views/comuser/dashboard/comuser_dashboard.vue'),
          meta: {
            is_company_user: true,
            requiresAuth: true,
            title: 'Dashboard',
            rule: 'editor'
          },
        },
        {
          path: '/user/chat',
          name: 'user-chat',
          component: () => import('@/views/comuser/comuserp2p/Chat.vue'),
          meta: {
            is_company_user: true,
            requiresAuth: true,
            title: 'Messaging',
            rule: 'editor',
          },
      },

      {
        path: '/user/bulk',
        name: 'user-bulk',
        redirect: { name: 'user-bulk-list' },
        component: () => import('./views/comuser/bulk-report/Index.vue'),
        meta: {
          // is_admin:true,
          requiresAuth: true,
          rule: 'editor'
        },
        children: [
          {
            path: 'list',
            name: 'user-bulk-list',
            component: () => import('./views/comuser/bulk-report/List.vue'),
            meta: {
              is_user:true,
              requiresAuth: true,
              rule: 'editor',
              pageTitle: 'Bulk Report',
              breadcrumb: [
                { title: 'Home', url: '/' },
                { title: 'List', active: true }
              ]
            },
          },
        ]
      },
      {
        path: '/user/smsreport',
        name: 'user-smsreport',
        redirect: { name: 'user-smsreport-list' },
        component: () => import('./views/comuser/sms-report/Index.vue'),
        meta: {
          // is_admin:true,
          requiresAuth: true,
          rule: 'editor'
        },
        children: [
          {
            path: 'list',
            name: 'user-smsreport-list',
            component: () => import('./views/comuser/sms-report/List.vue'),
            meta: {
              is_user:true,
              requiresAuth: true,
              rule: 'editor',
              pageTitle: 'SMS Report',
              breadcrumb: [
                { title: 'Home', url: '/' },
                { title: 'List', active: true }
              ]
            },
          },
        ]
      },
      {
        path: '/user/smslog/inbound',
        name: 'user-smslog-inbound',
        redirect: { name: 'user-smslog-inbound-list' },
        component: () => import('./views/comuser/smslog/inbound/Index.vue'),
        meta: {
          // is_admin:true,
          requiresAuth: true,
          rule: 'editor'
        },
        children: [
          {
            path: 'list',
            name: 'user-smslog-inbound-list',
            component: () => import('./views/comuser/smslog/inbound/List.vue'),
            meta: {
              is_user:true,
              requiresAuth: true,
              rule: 'editor',
              pageTitle: 'SMS Log',
              breadcrumb: [
                { title: 'Home', url: '/' },
                { title: 'Inbound', active: true }
              ]
            },
          },
        ]
      },
      {
        path: '/user/smslog/outbound',
        name: 'user-smslog-outbound',
        redirect: { name: 'user-smslog-outbound-list' },
        component: () => import('./views/comuser/smslog/outbound/Index.vue'),
        meta: {
          // is_admin:true,
          requiresAuth: true,
          rule: 'editor'
        },
        children: [
          {
            path: 'list',
            name: 'user-smslog-outbound-list',
            component: () => import('./views/comuser/smslog/outbound/List.vue'),
            meta: {
              // is_admin:true,
              requiresAuth: true,
              rule: 'editor',
              pageTitle: 'SMS Log',
              breadcrumb: [
                { title: 'Home', url: '/' },
                { title: 'Outbound', active: true }
              ]
            },
          },

        ]
      },

      ]
    },


    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path:'/company_admin_table1',
          name:'company_admin_table1',
          component: () => import('./views/company-admin/dashboard/company_admin_table1.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path:'/call_flow_listing',
          name:'call_flow_listing',
          component: () => import('./views/company-admin/CallFlow/call_flow_listing.vue'),
          meta:{
            rule:'editor'
          }
        },
       {
         path:'/compaign_list',
         name:'compaign_list',
         component: () => import('./views/company-admin/CompaignList/compaign_list.vue'),
         meta:{
           rule:'editor'
         }
       },
        {
          path: '/callback',
          name: 'auth-callback',
          component: () => import('@/views/Callback.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/login',
          name: 'login',
          component: () => import('@/views/auth/login/Login.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/register',
          name: 'register',
          component: () => import('@/views/pages/register/Register.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/forgot-password',
          name: 'forgot-password',
          component: () => import('@/views/pages/ForgotPassword.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/reset-password',
          name: 'page-reset-password',
          component: () => import('@/views/pages/ResetPassword.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/lock-screen',
          name: 'page-lock-screen',
          component: () => import('@/views/pages/LockScreen.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/comingsoon',
          name: 'page-coming-soon',
          component: () => import('@/views/pages/ComingSoon.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/error-500',
          name: 'page-error-500',
          component: () => import('@/views/pages/Error500.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/not-authorized',
          name: 'page-not-authorized',
          component: () => import('@/views/pages/NotAuthorized.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/maintenance',
          name: 'page-maintenance',
          component: () => import('@/views/pages/Maintenance.vue'),
          meta: {
            rule: 'editor'
          }
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/'
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})



router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('user-token')
  let  user_type = localStorage.getItem('user-type')
  user_type = (user_type === 'user') ? 'comuser':user_type;
  if (to.name === 'login') {
    if (token) {

      if(user_type === 'admin'){
        next({ name: 'admin' })
      }else if(user_type === 'company_admin'){
        next({ name: 'company_admin' })
      }else if(user_type === 'comuser'){
        next({ name: 'comuser' })
      }else if(user_type === 'reseller'){
        next({ name: 'reseller' })
      }

    } else {
      next()
    }
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters['auth/IsAuthenticated']) {
      next({
        path: "/login",
        params: {nextUrl: to.fullPath}
      });
    } else {
      const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.pageTitle);
      console.log('user_type',user_type)

      //store.commit('setPageHeader', nearestWithTitle.meta.pageTitle);

      if (to.matched.some(record => record.meta.is_company_admin)) {
        if (user_type === "company_admin") {
          next();
        } else {
          next({
            name: user_type
          });
        }
      } else if (to.matched.some(record => record.meta.is_admin)) {
        if (user_type === "admin") {
          next();
        } else {
          next({
            name: user_type
          });
        }
      } else if (to.matched.some(record => record.meta.is_company_user)) {
        if (user_type === "comuser") {
          next();
        } else {
          next({ name: 'comuser' })
        }
      } else if (to.matched.some(record => record.meta.is_reseller)) {
        if (user_type === "reseller") {
          next();
        } else {
          next({
            name: 'reseller'
          });
        }
      } else {
        next();
      }
    }
  } else {
    next()
  }
})

export default router
